import { render, staticRenderFns } from "./PIC.vue?vue&type=template&id=293fd1ce&scoped=true"
import script from "./PIC.vue?vue&type=script&lang=js"
export * from "./PIC.vue?vue&type=script&lang=js"
import style0 from "./PIC.vue?vue&type=style&index=0&id=293fd1ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293fd1ce",
  null
  
)

export default component.exports